import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { Theme, ThemeMeta, THEMES } from "../hooks/useTheme";

const DEFAULT: Theme = "blueprint";
const STORAGE_KEY = "qba-theme";

const QBAThemeContext = createContext<{
  theme: Theme;
  setTheme: (t: Theme) => void;
}>({ theme: DEFAULT, setTheme: () => {} });

export function QBAThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
    return THEMES.find((t: ThemeMeta) => t.id === stored) ? (stored as Theme) : DEFAULT;
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = (next: Theme) => {
    if (THEMES.find((t: ThemeMeta) => t.id === next)) setThemeState(next);
  };

  return (
    <QBAThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </QBAThemeContext.Provider>
  );
}

export const useQBATheme = () => useContext(QBAThemeContext);